import { TeamModel } from "./Team";

export class BattingStatisticsModel {
    public year = '';
    public type = '';
    public avg = '';
    public r = '';
    public hr = '';
    public rbi = '';
    public sb = '';
    public g = '';
    public ab = '';
    public bb = '';
    public ibb = '';
    public sf = '';
    public sac = '';
    public hbp = '';
    public h = '';
    public h2b = '';
    public h3b = '';
    public so = '';
    public cs = '';
    public obp = '';
    public slg = '';
    public ops = '';
    public pk = '';
    public tb = '';
    public w = '';
    public l = '';
    public lob = '0';
    public opponent: TeamModel = new TeamModel();
    public isHome = false;
    public get opp(): string {
        return (this.isHome ? '' : '@') + this.opponent.abbrU;
    }
    public date: Date = new Date();

    constructor(obj?: any) {
        if (obj) {
            this.year = typeof obj.year !== 'undefined' ? obj.year : '';
            this.avg = typeof obj.avg !== 'undefined' ? obj.avg : '';
            this.slg = typeof obj.slg !== 'undefined' ? obj.slg : '';
            this.obp = typeof obj.obp !== 'undefined' ? obj.obp : '';
            this.ab = typeof obj.ab !== 'undefined' ? obj.ab : '';
            this.r = typeof obj.r !== 'undefined' ? obj.r : '';
            this.h = typeof obj.h !== 'undefined' ? obj.h : '';
            this.hbp = typeof obj.hbp !== 'undefined' ? obj.hbp : '';
            this.h2b = typeof obj.h2b !== 'undefined' ? obj.h2b : '';
            this.h3b = typeof obj.h3b !== 'undefined' ? obj.h3b : '';
            this.hr = typeof obj.hr !== 'undefined' ? obj.hr : '';
            this.rbi = typeof obj.rbi !== 'undefined' ? obj.rbi : '';
            this.bb = typeof obj.bb !== 'undefined' ? obj.bb : '';
            this.so = typeof obj.so !== 'undefined' ? obj.so : '';
            this.pk = typeof obj.pk !== 'undefined' ? obj.pk : '';
            this.sf = typeof obj.sf !== 'undefined' ? obj.sf : '';
            this.sac = typeof obj.sac !== 'undefined' ? obj.sac : '';
            this.tb = typeof obj.tb !== 'undefined' ? obj.tb : ''; 
            this.ops = typeof obj.ops !== 'undefined' ? obj.ops : ''; 
            this.lob = typeof obj.lob !== 'undefined' ? obj.lob : '';
            this.cs = typeof obj.cs !== 'undefined' ? obj.cs : ''; 
            this.ibb = typeof obj.ibb !== 'undefined' ? obj.ibb : ''; 
            this.g = typeof obj.g !== 'undefined' ? obj.g : ''; 
            this.sb = typeof obj.sb !== 'undefined' ? obj.sb : '';
        }
    }
}